import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import LeaveAdminHeader from '@hr/components/LeaveAdmin/LeaveAdminHeader.vue';
import LeaveAdminList from '@hr/components/LeaveAdmin/LeaveAdminList.vue';
import PageNavigationBar from '@appbase/components/Paginate/PageNavigationBar.vue';
import api from '@hr/api';
import * as dateutil from '@appbase/util/date-helper';



@Component ({
    components: { LeaveAdminHeader, LeaveAdminList, PageNavigationBar }
})
export default class LeaveAdminContainer extends Vue {
  
    @Prop({ type: Boolean }) isPersonView!: boolean
    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    items: Array<any> = [];
    totalCount: number = 0;
    searchFilter: string = 'name';
    searchWord: string = '';
    pageNum: number = 1;
    rowSize: number = 20;
    leaveCode: number = 0;
    todayDate: Date = new Date();
    // startDate: string =  dateutil.uGetDateFormat('yyyy-MM-DD', new Date(new Date(this.todayDate.setDate(1)).setMonth(1)));
    // endDate: string =  dateutil.uGetDateFormat('yyyy-MM-DD', new Date());
    startDate =  dateutil.uGetDateFormat('yyyy-MM-DD', new Date(new Date().setMonth(0, 1)));
    endDate =  dateutil.uGetDateFormat('yyyy-MM-DD', new Date(new Date().setMonth(11, 31)));


    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

  

    load(data: any) {
        const {searchFilter, searchWord, pageNum, rowSize, startDate, endDate, leaveCode} = data;

        this.searchFilter = searchFilter;
        this.searchWord = searchWord;
        this.pageNum = pageNum;
        this.rowSize = rowSize;
        api.leave.getLeaveAdminList(searchFilter, searchWord, pageNum, rowSize,startDate, endDate, leaveCode, this.isPersonView).then((res: any) => {
            if (res) {
                    this.items = res.items;
                    this.totalCount = res.totalCount;
            }
        });
    }

    pageMove(number: number) {
        var data = {
            searchFilter: this.searchFilter,
            searchWord: this.searchWord,
            pageNum: number,
            rowSize: this.rowSize,
            startDate: this.startDate,
            endDate: this.endDate,
            isPersonReq : this.isPersonView,
            leaveCode: this.leaveCode,
        }
        this.load(data);
    }

    selectType(value:any){
        this.searchFilter = value
    }

    selectLeaveCode(value:any){
        
        this.leaveCode = value
    }
    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y L E : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    @Watch('isPersonView')
    onQueryChanged(){
        var data = {
            searchFilter: this.searchFilter,
            searchWord: this.searchWord,
            pageNum: this.pageNum,
            rowSize: this.rowSize,
            startDate: this.startDate,
            endDate: this.endDate,
            leaveCode: this.leaveCode,
            isPersonReq: this.isPersonView
        }
        this.$nextTick(()=>{
            this.load(data);
        })
        

        if(this.isPersonView){
            this.setPage({title:this.$t('휴가내역조회')});
        }else{
            this.setPage({title:this.$t('휴가신청내역')});
        }
    }


    created() {
        if(this.isPersonView){
            this.setPage({title:this.$t('휴가내역조회')});
        }else{
            this.setPage({title:this.$t('휴가신청내역')});
        }
        
        var data = {
            searchFilter: this.searchFilter,
            searchWord: this.searchWord,
            pageNum: this.pageNum,
            rowSize: this.rowSize,
            startDate: this.startDate,
            endDate: this.endDate,
            leaveCode: this.leaveCode,
            isPersonReq: this.isPersonView
        }
        this.load(data);
    }

}
